import CardTitle from '@auteco/components/sharedComponents/CardTitle'
import { TableConfig } from '@auteco/components/snopComponents'
import React from 'react'

const SnopConfigPage = () => (
    <>
        <CardTitle title='Configuación' />
        <TableConfig />
    </>
)

export { SnopConfigPage }